import { render, staticRenderFns } from "./TradeRequested.vue?vue&type=template&id=fb282a76&scoped=true&"
import script from "./TradeRequested.vue?vue&type=script&lang=ts&"
export * from "./TradeRequested.vue?vue&type=script&lang=ts&"
import style0 from "./TradeRequested.vue?vue&type=style&index=0&id=fb282a76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb282a76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
